/* Persistent store */
import { writable, readable, derived } from 'svelte-persistent-store/dist/local';


export const position=writable('uloc',null);
export const lastPosition=writable('luloc',null);
export const gotPosition=writable('gotLoc',false);
